/**
 * Shared front-end helpers for working with a loaded saved-progress record.
 *
 * Ninja Forms core renders the Submit button as type="submit" (commit 6e18d02b),
 * so the browser performs its own native form submission alongside Ninja Forms'
 * AJAX submission. Loading a saved record resets the fields collection, which
 * re-renders the form and leaves that native submission unsuppressed: the page
 * reloads with the field values in the query string and the success message is
 * never shown.
 *
 * Every path that resets the fields collection must suppress that native
 * submission, and every path that stops working from a record must forget it.
 * Issue #289 and issue #290 were both caused by the saved-progress table's row
 * actions missing one of these while the automatic single-save path had the other.
 * They live here so a future load path cannot silently miss them again.
 */

/**
 * Suppress the browser's own submission of this form until Ninja Forms has
 * responded to the next submission.
 *
 * Safe to call repeatedly: the handler is namespaced and removed before it is
 * re-bound, so loading several records in a row never stacks duplicate handlers.
 *
 * @param {string|number} formInstanceID
 */
var nfSaveProgressSuppressNativeSubmit = function( formInstanceID ) {

    var $form = jQuery( '#nf-form-' + formInstanceID + '-cont form' );

    $form.off( 'submit.nfSaveProgress' ).on( 'submit.nfSaveProgress', function( e ) {
        e.preventDefault();
    } );

    Backbone.Radio.channel( 'form-' + formInstanceID ).once( 'submit:response', function() {
        $form.off( 'submit.nfSaveProgress' );
    } );
};

/**
 * Record which saved record this form is now working from.
 *
 * Passing no save ID clears it, which is what backing out of a record must do:
 * the submission pipeline deletes the record named by save_id, so a stale value
 * left behind destroys a record the visitor chose not to use (issue #290).
 *
 * @param {string|number} formInstanceID
 * @param {string|number} [saveID] Omit to clear.
 */
var nfSaveProgressSetLoadedSave = function( formInstanceID, saveID ) {

    var formModel = Backbone.Radio.channel( 'app' ).request( 'get:form', formInstanceID );

    if( 'undefined' == typeof formModel ) return;

    if( 'undefined' == typeof saveID || ! saveID ) {
        formModel.unset( 'save_id' );
        return;
    }

    formModel.set( 'save_id', saveID );
};
